import { render, staticRenderFns } from "./ReportActiveSuppliers.vue?vue&type=template&id=b04f7560"
import script from "./ReportActiveSuppliers.vue?vue&type=script&lang=js"
export * from "./ReportActiveSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports